export default {
  title: 'Galerie',
  sections: {
    logo: 'Logo',
    web_images: 'Images de galerie pour la commande en ligne',
  },
  toasts: {
    image_uploaded: 'Modifications enregistrées avec succès',
    image_upload_failed: "Échec de l'enregistrement des modifications",
  },
};
